import { notEmpty } from "@product/scmp-sdk";
import { useAtomValue } from "jotai";
import first from "lodash/first";
import type { FunctionComponent } from "react";
import { useRef } from "react";
import { SwitchTransition } from "react-transition-group";

import type { AppBarVariant } from "scmp-app/components/app-bar/types";
import { gdprAtom } from "scmp-app/components/tracking/gdpr/hooks";
import { Fade } from "scmp-app/components/transition/fade";

import { useAccountActivation } from "./account-activation/hooks";
import { useEditionInvitation } from "./edition-invitation/hooks";
import { useNotifications } from "./notification/hooks";
import { NewsTickerContainer } from "./styles";

export type Props = {
  appBarVariant?: AppBarVariant;
};

export const NewsTicker: FunctionComponent<Props> = ({ appBarVariant }) => {
  const gdprStatus = useAtomValue(gdprAtom);
  const { breakingNewsNotification, currentSectionNotification } = useNotifications();
  const accountActivation = useAccountActivation();
  // TODO: missing refresh ad when close
  const { component: editionInvitation, isLoading: isEditionInvitationLoading } =
    useEditionInvitation();

  const isPlusPage = appBarVariant?.startsWith("scmp/plus");

  const items = [
    {
      disabled: isPlusPage,
      isLoading: isEditionInvitationLoading,
      key: "editionInvitation",
      value: editionInvitation,
    },
    { key: "accountActivation", value: accountActivation },
    { disabled: isPlusPage, key: "breakingNotification", value: breakingNewsNotification },
    { disabled: isPlusPage, key: "sectionNotification", value: currentSectionNotification },
  ].filter(element => notEmpty(element.value) && !element.disabled);
  const firstItem = first(items);
  const shouldShow = items.length > 0;

  const reference = useRef<HTMLDivElement>(null);

  if (!gdprStatus.isAccepted || firstItem?.isLoading === true || appBarVariant === "scmp/home")
    return null;
  return (
    <Fade inProperty={shouldShow} nodeRef={reference}>
      <NewsTickerContainer ref={reference}>
        <SwitchTransition mode="out-in">
          <Fade inProperty={true} key={firstItem?.key}>
            {firstItem?.value}
          </Fade>
        </SwitchTransition>
      </NewsTickerContainer>
    </Fade>
  );
};
NewsTicker.displayName = "NewsTicker";
